module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-rewards"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.rewards_dashboard.nav_space'),
      "hideAuxNavOnDesktop": true,
      "backButton": _vm.showBackButton
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-rewards__main"
  }, [_c('search-bar'), _vm._v(" "), (_vm.categoriesLoading) ? _c('loading-icon') : _c('category-list')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b576140"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RewardsDashboard.vue
// module id = 536
// module chunks = 1